<template>
  <CalendarPicker
    :value="value"
    :mode="mode"
    :minDate="minDate"
    :maxDate="maxDate"
    :predefinedRanges="predefinedRanges"
    :adjustDatesOutsideRange="true"
    :show="show"
    @click="$emit('click', $event)"
    @applyContinueClick="$emit('applyContinueClick', $event)"
    @controlClick="$emit('controlClick', $event)"
    :isMultipleOptionVariant="isMultipleOptionVariant"
  ></CalendarPicker>
</template>
<script>
import { CalendarPicker } from '@mikmak/components';
import { predefinedRanges } from '../../../services/dashboard/dates/predefinedRanges';

export default {
  props: {
    value: {
      type: Object,
      validator: v => {
        return v !== undefined
          && v.range !== undefined
          && v.predefinedRangeValue !== undefined;
      },
    },
    mode: {
      type: String,
    },
    show: {
      type: Boolean,
    },
    minDate: {
      type: [Date, Number],
    },
    maxDate: {
      type: [Date, Number],
    },
    isMultipleOptionVariant: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      predefinedRanges,
    };
  },
  components: {
    CalendarPicker,
  },
};
</script>
